import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { VersionFooter } from './VersionFooter'
import { useAppStore } from '@/stores/appStore'
import { cn } from '@/lib/utils'

export function DashboardLayout() {
  const { sidebarOpen } = useAppStore()

  return (
    <div className="min-h-screen bg-slate-950 pb-8">
      {/* Background glowing orbs - matching landing page */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-whale-500/20 rounded-full blur-3xl" />
        <div className="absolute top-1/3 right-1/4 w-80 h-80 bg-blue-500/15 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 left-1/3 w-72 h-72 bg-whale-600/10 rounded-full blur-3xl" />
      </div>

      <Sidebar />

      <div
        className={cn(
          'relative transition-all duration-300 ease-out',
          sidebarOpen ? 'lg:pl-64' : 'lg:pl-20'
        )}
      >
        <Header />
        <main className="relative p-6 lg:p-8">
          {/* Content wrapper with max width for ultra-wide screens */}
          <div className="mx-auto max-w-7xl">
            <Outlet />
          </div>
        </main>
      </div>

      <VersionFooter />
    </div>
  )
}
